import { NavBar, CapsuleTabs, Button, Toast, Dialog } from 'antd-mobile';
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import TeamList from '../Team/TeamList';
import GameYearGameList from './GameYearGameList';
import ActiveCharts from '../Team/ActiveCharts';
import { FillinOutline, EnvironmentOutline, PlayOutline, DeleteOutline, CheckCircleOutline, TravelOutline } from 'antd-mobile-icons'
import './index.css';
import { useAuth } from '../app/providers/AuthProvider';
import { gameYearApi } from '../features/game-year/api/gameYearApi';

export default function GameYear() {

    const navigate = useNavigate();

    const { memberInfo } = useAuth();

    const location = useLocation();
    const { gameYearId: routeGameYearId } = useParams();
    const stateGameYearId = location.state?.yearId;
    const gameYearId = routeGameYearId || stateGameYearId;

    const [gameYearInfo, setGameYearInfo] = useState({})
    const yearStatusText = { 0: '筹备中', 1: '进行中', 2: '已结束' }[gameYearInfo?.status] || '加载中'

    useEffect(() => {
        // 将旧的路由 state 入口规范化为包含活动 ID 的 URL。
        if (!routeGameYearId && stateGameYearId) {
            navigate(`/game-years/${stateGameYearId}`, { replace: true });
        }
    }, [navigate, routeGameYearId, stateGameYearId]);

    const getYearGameInfo = useCallback(() => {
        Toast.show({
            icon: 'loading',
            content: '加载中...',
            duration: 0
        })
        gameYearApi.getInfo(gameYearId)
            .then(function (response) {
                const resultData = response.data.data
                setGameYearInfo(resultData)
                Toast.clear()
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！',
                    afterClose: () => {
                        Toast.clear()
                    }
                })
            })
            .finally(() => {
            });
    }, [gameYearId])

    useEffect(() => {
        // 年会详情属于副作用请求，活动 ID 变化时重新加载。
        if (!gameYearId) {
            Toast.show({ icon: 'fail', content: '缺少年会活动信息' });
            navigate('/gameYearList', { replace: true });
            return;
        }
        getYearGameInfo()
    }, [gameYearId, getYearGameInfo, navigate])

    const updateStatus = (status) => {
        gameYearApi.save({
            id: gameYearInfo.id,
            status: status,
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '状态更新成功！',
                        icon: 'success',
                        afterClose: () => getYearGameInfo(),
                    })
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail',
                    })
                }
            })
            .catch(() => {
                Toast.show({
                    content: '操作失败,请重试!',
                    icon: 'fail'
                })
            });
    }

    const deleteActivity = () => {
        gameYearApi.save({
            id: gameYearInfo.id,
            deleteFlag: 1,
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '删除成功！',
                        icon: 'success',
                        afterClose: () => {
                            window.history.back()
                        },
                    })
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail'
                    })
                }
            })
            .catch(() => {
                Toast.show({
                    content: '删除失败!',
                    icon: 'fail'
                })
            });
    }

    return (
        <div className="game-year-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                年会活动详情
            </NavBar>
            <div className="year-detail-hero">
                <div className={`year-status-pill year-status-pill--${gameYearInfo?.status}`}>{yearStatusText}</div>
                <div className="year-detail-title">{gameYearInfo.gameName}</div>
                <div className="year-detail-time">{gameYearInfo.gameTime}</div>

                {memberInfo && memberInfo.admin === 1 && (
                    <div className="year-admin-bar">
                        <button type="button" className="year-admin-btn primary" title="修改信息" onClick={() => {
                            Dialog.confirm({
                                title: '去修改活动信息吗？',
                                onConfirm: () => {
                                    navigate('/gameYearUpdate', { state: { yearInfo: gameYearInfo } });
                                }
                            })
                        }}>
                            <FillinOutline /><span>编辑</span>
                        </button>
                        
                        {gameYearInfo.status === 0 && (
                            <button type="button" className="year-admin-btn success" title="开始活动" onClick={() => {
                                Dialog.confirm({
                                    title: '当前年会活动开始？',
                                    onConfirm: () => updateStatus(1)
                                })
                            }}>
                                <PlayOutline /><span>开始活动</span>
                            </button>
                        )}

                        {gameYearInfo.status === 1 && (
                            <button type="button" className="year-admin-btn success" title="结束活动" onClick={() => {
                                Dialog.confirm({
                                    title: '当前年会活动结束了吗？',
                                    onConfirm: () => updateStatus(2)
                                })
                            }}>
                                <CheckCircleOutline /><span>结束活动</span>
                            </button>
                        )}

                        <button type="button" className="year-admin-btn danger" title="删除活动" onClick={() => {
                            Dialog.confirm({
                                title: '是否删除当前年会活动？',
                                onConfirm: () => deleteActivity()
                            })
                        }}>
                            <DeleteOutline /><span>删除</span>
                        </button>
                    </div>
                )}
            </div>
                {/* 年会详情只展示正赛、排行与队伍，体测项目不再占用页签。 */}
                <CapsuleTabs className="year-detail-tabs" defaultActiveKey={"game"}>
                    <CapsuleTabs.Tab title='活动项目' key='game'>
                        <div style={{ padding: '0 16px' }}>
                            <div className="year-info-card">
                                <div className="year-info-icon-box">
                                    <TravelOutline />
                                </div>
                                <div className="year-info-content">
                                    <div className="year-info-label">比赛场地</div>
                                    <div className="year-info-value">{gameYearInfo?.gameAddress}</div>
                                </div>
                            </div>

                            {gameYearInfo?.dinnerAddress && (
                                <div className="year-info-card">
                                    <div className="year-info-icon-box" style={{ background: 'rgba(255, 125, 0, 0.08)', color: '#FF7D00' }}>
                                        <EnvironmentOutline />
                                    </div>
                                    <div className="year-info-content">
                                        <div className="year-info-label">聚餐地点</div>
                                        <div className="year-info-value">{gameYearInfo?.dinnerAddress}</div>
                                    </div>
                                </div>
                            )}

                            <div className="year-section-title">年会正赛</div>
                            <GameYearGameList gameYearId={gameYearId} canCreate={gameYearInfo?.status !== 2} />
                        </div>
                    </CapsuleTabs.Tab>
                    <CapsuleTabs.Tab title='排行数据' key='charts'>
                        <ActiveCharts gameYearId={gameYearId} />
                    </CapsuleTabs.Tab>
                    <CapsuleTabs.Tab title='队伍信息' key='team'>
                        <div style={{ padding: '0 16px' }}>
                            {memberInfo && memberInfo.admin === 1 && gameYearInfo?.status !== 2 &&
                                <Button
                                    block
                                    className="create-activity-btn"
                                    style={{ margin: '10px 0 20px' }}
                                    onClick={() => navigate('/createTeam', { state: { yearId: gameYearId } })}>
                                    ＋ 创建活动队伍
                                </Button>
                            }
                            <TeamList gameId={gameYearId} />
                        </div>
                    </CapsuleTabs.Tab>
                </CapsuleTabs>
        </div>
    )
}
